<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { TenantService } from '@/config/tenant';

// Mevcut tenant adını alıyoruz
const currentTenant = computed(() => TenantService.getCurrentTenantName());

const router = useRouter();
const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
    <div class="layout-footer">
        <div class="w-full flex justify-end items-center gap-2">
            <div class="ml-auto">
                © {{ currentYear }} İnoslab Ventures - Tüm Hakları Saklıdır. {{ currentTenant }}
            </div>
            <div>
                <Button icon="pi pi-verified" rounded text plain @click="router.push('/pages/version')" />
            </div>
        </div>
    </div>
</template>
